import { render, staticRenderFns } from "./phone-talk.vue?vue&type=template&id=33580fd6&scoped=true&"
var script = {}
import style0 from "./phone-talk.vue?vue&type=style&index=0&id=33580fd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33580fd6",
  null
  
)

export default component.exports